module.exports = __webpack_public_path__ + "assets/certificate_pdf/ssa_113_3.a676b11a.pdf";